import request from '../../../../../../../api/request';

const BASE = '/maintainers-portal/financial-portal/settings/charge-items';

export type ChargeItemInvoiceType = 'afecta' | 'exenta';

export interface ChargeItem {
  id: number;
  name: string;
  code: string;
  /** null = "Sin centro de costo". */
  costCenterId: number | null;
  costCenterName: string | null;
  description: string | null;
  currencyId: number | null;
  currencyCode: string | null;
  amount: number | null;
  invoiceType: ChargeItemInvoiceType;
  appliesCollectionFee: boolean;
  appliesLateInterest: boolean;
}

export interface ChargeItemPayload {
  name: string;
  code: string;
  costCenterId: number | null;
  description: string | null;
  currencyId: number;
  amount: number;
  invoiceType: ChargeItemInvoiceType;
  appliesCollectionFee: boolean;
  appliesLateInterest: boolean;
}

/** Cuerpo del 409 cuando el código ya está tomado por otro ítem vigente. */
export interface ChargeItemCodeTakenError {
  code: 'CODE_TAKEN';
}

export function getChargeItems() {
  return request<ChargeItem[]>(BASE);
}

export function createChargeItem(body: ChargeItemPayload) {
  return request<ChargeItem>(BASE, { method: 'post', data: body });
}

export function updateChargeItem(id: number, body: ChargeItemPayload) {
  return request<ChargeItem>(`${BASE}/${id}`, { method: 'put', data: body });
}

export function deleteChargeItem(id: number) {
  return request<void>(`${BASE}/${id}`, { method: 'delete' });
}
